const config = {
    VERSION: process.env.REACT_APP_VERSION || '1.0.1', // Default to 1.0.0 if not set in .env
};

export default config;